import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class UserPageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/admin/users': this.users,
      '/dashboard/admin/users/:id/profile': this.profile,
      '/dashboard/admin/users/:id/billing': this.billing,
      '/dashboard/users/organizations/:id/account': this.organizationAccount,
      '/dashboard/users/organizations/:id/team': this.organizationTeam,
      '/dashboard/users/organizations/:id/billing': this.organizationBilling,
    };
  }

  static get users() {
    return [
      'tag:user',
      'tag:list',
    ];
  }

  static get profile() {
    return [
      'tag:user',
      'tag:profile',
      'tag:detail',
    ];
  }

  static get billing() {
    return [
      'tag:user',
      'tag:billing',
      'tag:detail',
    ];
  }

  static get organizationAccount() {
    return [
      'tag:organization',
      'tag:account',
      'tag:detail',
    ];
  }

  static get organizationTeam() {
    return [
      'tag:organization',
      'tag:team',
      'tag:detail',
    ];
  }

  static get organizationBilling() {
    return [
      'tag:organization',
      'tag:billing',
      'tag:detail',
    ];
  }
}


export default UserPageTags;
